import React from 'react';
import { IQueryClient, QueryContext } from './state';

export function QueryProvider({ client, children }: { client: IQueryClient; children: React.ReactNode }) {
  return <QueryContext.Provider value={client}>{children}</QueryContext.Provider>;
}
